import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/styles/site.css";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AuthProvider } from "@/context/AuthContext";
import { AdminGuard } from "@/components/admin/AdminShell";
import Home from "@/pages/Home";
import SeoServices from "@/pages/SeoServices";
import TechnicalSeo from "@/pages/TechnicalSeo";
import LocalSeo from "@/pages/LocalSeo";
import Results from "@/pages/Results";
import ServicePage from "@/pages/ServicePage";
import Insights from "@/pages/Insights";
import InsightPost from "@/pages/InsightPost";
import LocationPage from "@/pages/LocationPage";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Studio from "@/pages/Studio";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminPosts from "@/pages/admin/AdminPosts";
import AdminEditor from "@/pages/admin/AdminEditor";
import { BASENAME, setAlternates } from "@/lib/i18n";
import LOCATIONS from "@/data/locations.json";
import { ECOMMERCE, B2B, INTERNATIONAL } from "@/data/seoPages";
import { AI_VISIBILITY, AEO, GEO } from "@/data/aiPages";

const SERVICE_PAGES = [ECOMMERCE, B2B, INTERNATIONAL, AI_VISIBILITY, AEO, GEO];

const Site = () => {
  const { pathname } = useLocation();
  const admin = pathname.startsWith("/admin");
  const noFooter = admin || pathname === "/studio";
  useEffect(() => { setAlternates(); }, [pathname]);
  return (
    <>
      {!admin && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/seo-services" element={<SeoServices />} />
          <Route path="/technical-seo" element={<TechnicalSeo />} />
          <Route path="/local-seo" element={<LocalSeo />} />
          {SERVICE_PAGES.map((p) => <Route key={p.path} path={p.path} element={<ServicePage key={p.path} page={p} />} />)}
          {LOCATIONS.map((l) => <Route key={l.slug} path={`/${l.slug}`} element={<LocationPage key={l.slug} slug={l.slug} />} />)}
          <Route path="/results" element={<Results />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightPost />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminGuard />}>
            <Route index element={<AdminPosts />} />
            <Route path="posts/new" element={<AdminEditor key="new" />} />
            <Route path="posts/:id" element={<AdminEditor />} />
          </Route>
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!noFooter && <Footer />}
    </>
  );
};

function App() {
  return (
    <BrowserRouter basename={BASENAME}>
      <AuthProvider>
        <SmoothScroll />
        <Site />
        <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "#170C30", border: "1px solid rgba(196,181,253,0.25)", color: "#fff", fontFamily: "Manrope" } }} />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
